import Store from './store';

const lsStore = Store({
    companyAdvancedFilter: null,
    companyMemberSearchQuery: null,
    companyStatusSelection: null,
    companyDateRange: null,
    companySelectedTeam: null,
}, 'company_task_persistence');

export function setAdvancedFilters (value = null) {
    lsStore.commit('save', {
        key: 'companyAdvancedFilter',
        value: value,
    });
}

export function getAdvancedFilters () {
    return lsStore.state.companyAdvancedFilter;
}

export function setTeamMemberSearchQuery (value = null) {
    lsStore.commit('save', {
        key: 'companyMemberSearchQuery',
        value: value,
    });
}

export function getTeamMemberSearchQuery () {
    return lsStore.state.companyMemberSearchQuery;
}

export function setStatusSelection (value = null) {
    lsStore.commit('save', {
        key: 'companyStatusSelection',
        value: value,
    });
}

export function getStatusSelection () {
    return lsStore.state.companyStatusSelection;
}

export function setDateRange (value = null) {
    lsStore.commit('save', {
        key: 'companyDateRange',
        value: value,
    });
}

export function getDateRange () {
    return lsStore.state.companyDateRange;
}

export function setSelectedTeam (value = null) {
    lsStore.commit('save', {
        key: 'companySelectedTeam',
        value: value,
    });
}

export function getSelectedTeam () {
    return lsStore.state.companySelectedTeam;
}
